var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolumeSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25V15.75C6.375 15.75 4.42444 12.3147 4.42444 12.3147H2.25C1.83579 12.3147 1.5 11.9789 1.5 11.5647V6.37905C1.5 5.96482 1.83579 5.62905 2.25 5.62905H4.42444C4.42444 5.62905 6.375 2.25 9 2.25Z",
    stroke: "#BABABA",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.625C12.2337 5.83369 12.4455 6.06739 12.6315 6.32205C13.177 7.0689 13.5 7.99586 13.5 9C13.5 9.99544 13.1826 10.915 12.6457 11.6585C12.4563 11.9207 12.2397 12.161 12 12.375",
    stroke: "#BABABA",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8385 15.4447C15.0314 14.1358 16.5 11.7394 16.5 9.00004C16.5 6.30323 15.0767 3.93885 12.9402 2.61719",
    stroke: "#BABABA",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeSpeaker);
export default __webpack_public_path__ + "static/media/volume-speaker.5c9d41d5ee48e8c40ffa81b8412f0bbc.svg";
export { ForwardRef as ReactComponent };